"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CodeEditorLanguage = exports.codeEditor = void 0;
function codeEditor(props) {
    return Object.assign({ type: "code-editor" }, props);
}
exports.codeEditor = codeEditor;
var CodeEditorLanguage;
(function (CodeEditorLanguage) {
    CodeEditorLanguage["Bash"] = "Bash";
    CodeEditorLanguage["CSharp"] = "CSharp";
    CodeEditorLanguage["FSharp"] = "FSharp";
    CodeEditorLanguage["PowerShell"] = "PowerShell";
    CodeEditorLanguage["Python"] = "Python";
    CodeEditorLanguage["HTML"] = "HTML";
    CodeEditorLanguage["CSS"] = "CSS";
    CodeEditorLanguage["Markdown"] = "Markdown";
    CodeEditorLanguage["DockerFile"] = "DockerFile";
    CodeEditorLanguage["INI"] = "INI";
    CodeEditorLanguage["CoffeeScript"] = "CoffeeScript";
    CodeEditorLanguage["JSON"] = "JSON";
    CodeEditorLanguage["PlainText"] = "PlainText";
    CodeEditorLanguage["XML"] = "XML";
    CodeEditorLanguage["YAML"] = "YAML";
})(CodeEditorLanguage = exports.CodeEditorLanguage || (exports.CodeEditorLanguage = {}));
//# sourceMappingURL=CodeEditor.js.map